"use client";  // Memastikan bahwa komponen ini dijalankan di sisi klien

import { useState } from "react";
import BlogComments from "@/components/detail-blog/blog-comments";
import { useTranslations } from "next-intl";

type PostCommentsToggleProps = {
    post: any; // Tipe post bisa disesuaikan dengan struktur data Anda
};

const PostCommentsToggle = ({ post }: PostCommentsToggleProps) => {
    const t = useTranslations("PostCommentsToggle");

    const [showComments, setShowComments] = useState(false);

    const handleToggleComments = () => {
        setShowComments(true); // Menampilkan komentar, dan tidak bisa disembunyikan lagi
    };

    return (
        <div>
            {!showComments && (
                <div className="flex justify-center mt-8">
                    <button
                        onClick={handleToggleComments}
                        className="px-4 py-2 text-white bg-blue-500 hover:bg-blue-700 rounded"
                    >
                        {t("showComments")}
                    </button>
                </div>
            )}

            {showComments && <BlogComments post={post} />}
        </div>
    );
};

export default PostCommentsToggle;
